import {bfsUserWebHttp, bfsSsoHttp, otmsHttp} from '@/utils/http/index.js'

export default function loginWithToken(data) {
    return bfsUserWebHttp.request({
      url: '/tenant_user/own/change_system',
      method: 'post',
      data,
    });
  }

/**
 * 统一登录
 * @param data
 * @returns {*}
 */
export function unifyLogin(data) {
    return bfsSsoHttp.request({
        url: '/unify_login',
        method: 'post',
        data,
    });
}

/**
 * token置换
 * @param data
 * @returns {*}
 */
export function transferToken(data) {
    return bfsUserWebHttp.request({
        url: '/bfs-sso/portal/transfer',
        method: 'post',
        data,
    });
}

export function getSmartAddress(data) {
    return otmsHttp.request({
        url: '/bfs_identity/nlp/address',
        method: 'post',
        data,
    });
}
